import React, { Component, PropTypes } from 'react';

class NavigationBar extends Component {

  static propTypes = {
    role: PropTypes.string,
    isPV: PropTypes.string,
    isCV: PropTypes.string,
    isPVCoverNote: PropTypes.string,
    isCVCoverNote: PropTypes.string
  }

  constructor(props) {
    super(props);
    this.state = { selectedEventKey: 1 };
    this.handleSelect = this.handleSelect.bind(this);
  }


  handleSelect(selectedKey) {
    this.setState({ selectedEventKey: selectedKey });
  }

  render() {
    return (
      <div>
            <nav className="navbar navbar-toggleable-md navbar-light bg-faded">
              <div className="collapse navbar-collapse" id="navbarNavDropdown">
                <ul className="navbar-nav">
                  <li className="nav-item dropdown">
                    <a className="nav-link dropdown-toggle" id="navbarDropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                      QUOTATION
                    </a>
                    <div className="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
                      {this.props.role !== 'admin' &&
                        (this.props.isPV === 'undefined' || this.props.isPV === 'false') &&
                        (this.props.isCV === 'undefined' || this.props.isCV === 'false') ?
                        <a className="dropdown-item disabled" href="/en/motorb2b/createNewQuotation">Create New Quotation</a> :
                        <a className="dropdown-item" href="/en/motorb2b/createNewQuotation">Create New Quotation</a>
                      }
                      {this.props.role !== 'admin' &&
                        (this.props.isPV === 'undefined' || this.props.isPV === 'false') &&
                        (this.props.isCV === 'undefined' || this.props.isCV === 'false') ?
                        <a className="dropdown-item disabled" href="/en/motorb2b/retrievequotation">Retrieve Quotation</a> :
                        <a className="dropdown-item" href="/en/motorb2b/retrievequotation">Retrieve Quotation</a>
                      }
                    </div>
                  </li>
                  <li className="nav-item dropdown">
                    <a className="nav-link dropdown-toggle" id="navbarDropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                      COVER NOTE
                    </a>
                    <div className="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
                      {this.props.role !== 'admin' &&
                        (this.props.isPVCoverNote === 'undefined' || this.props.isPVCoverNote === 'false') &&
                        (this.props.isCVCoverNote === 'undefined' || this.props.isCVCoverNote === 'false') ?
                        <a className="dropdown-item disabled" href="/en/motorb2b/createNewCoverNote">Create New Cover Note</a> :
                        <a className="dropdown-item" href="/en/motorb2b/createNewCoverNote">Create New Cover Note</a>
                      }
                      {this.props.role !== 'admin' &&
                        (this.props.isPVCoverNote === 'undefined' || this.props.isPVCoverNote === 'false') &&
                        (this.props.isCVCoverNote === 'undefined' || this.props.isCVCoverNote === 'false') ?
                        <a className="dropdown-item disabled" href="/en/motorb2b/retrievecovernote">Retrieve Cover Note</a> :
                        <a className="dropdown-item" href="/en/motorb2b/retrievecovernote">Retrieve Cover Note</a>
                      }
                    </div>
                  </li>
                  <li className="nav-item dropdown">
                    <a className="nav-link dropdown-toggle" id="navbarDropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                      GENERAL REPORT
                    </a>
                    <div className="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
                      <a className="dropdown-item" href="/en/motorb2b/agentsummaryreport">Agent Summary Report</a>
                      <a className="dropdown-item" href="/en/motorb2b/agenttransreport">Agent Transaction Report</a>
                      <a className="dropdown-item" href="/en/motorb2b/covernotereport">Cover Note Report</a>
                      {this.props.role === 'agent' ? null :
                        <a className="dropdown-item" href="/en/motorb2b/monitoringreport">Monitoring Report</a>
                      }
                    </div>
                  </li>
                </ul>
              </div>
            </nav>
      </div>
    )
  }

}

export default NavigationBar;



// WEBPACK FOOTER //
// ./src/app/components/navigation/NavigationBar.js